import React from "react";
import styled from "styled-components";
import TopBanner from "../components/TopBanner";
import ContactForm from "../components/ContactForm";
import { CTAButton, CTAButtonWrapper } from "../components/HeroSection";
const Contact = ({ openModal }) => {
  React.useEffect(() => {
    document.title = "Contact Wealthies – Get Insurance Guidance";
  }, []);

  return (
    <>
      <TopBanner content={"Contact Wealthies"} />
      <Wrapper>
        <Hero>
          <h1>
            We’re <span>Here</span> to Help
          </h1>
          <p>
            If you have questions about insurance or would like to connect with
            a licensed insurance professional, our team is here to assist you.
          </p>
          <p>
            You can reach out to us through the form below and our team will get
            back to you as soon as possible.
          </p>
        </Hero>

        <ContentWrapper>
          <FormCard>
            <h2 id="contact-form" style={{ textAlign: "center" }}>
              Get <span>In Touch</span>
            </h2>
            <ContactForm />
          </FormCard>
        </ContentWrapper>
        <MapSection>
          <h2>Our Location</h2>
          <iframe
            title="Our Office Location"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3889.755117820179!2d77.58524707507453!3d12.859086987446046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDUxJzMyLjciTiA3N8KwMzUnMTYuMiJF!5e0!3m2!1sen!2sin!4v1756015491222!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </MapSection>

        <SupportSection>
          <h2>
            Need <span>Quick</span> Assistance?
          </h2>
          <p>
            You can also request insurance guidance through our platform and
            connect with licensed insurance professionals.
          </p>
          <CTAButtonWrapper>
            <CTAButton onClick={openModal}>
              Get Free Insurance Guidance
            </CTAButton>
          </CTAButtonWrapper>
        </SupportSection>
      </Wrapper>
    </>
  );
};

export default Contact;

export const BrandWrapper = styled.span`
  color: #005f73 !important;
  font-weight: bold;
`;
const Wrapper = styled.div`
  padding: 80px 5%;
  max-width: 1400px;
  margin: 0 auto;
  h1,
  h2 {
    color: #005f73;

    span {
      color: #fdc500;
    }
  }
  #heading {
    text-align: center;
    font-size: 2.8rem;
    color: #005f73;
    margin-bottom: 40px;
  }
  span {
    color: #fdc500;
  }
`;

const Hero = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h1 {
    color: #005f73;
    font-size: 2.8rem;
    margin-bottom: 20px;
  }

  p {
    color: #333;
    max-width: 780px;
    margin: 0 auto 16px;
    line-height: 1.7;
    font-size: 20px;
  }
`;

const FormCard = styled.div`
  border-radius: 12px;
  padding: 20px;
  background: #f6faff;
  border: 1px solid #dbeffa;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.04);

  h2 {
    color: #005f73;
    margin-bottom: 16px;
  }
`;

const MapSection = styled.div`
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dbeffa;
  margin-bottom: 40px;
  margin-top: 30px;

  h2 {
    margin: 0;
    background: #f0f8ff;
    color: #005f73;
    padding: 16px;
    text-align: center;
  }

  iframe {
    width: 100%;
    height: 480px;
    border: 0;
  }

  @media (max-width: 900px) {
    iframe {
      height: 300px;
    }
  }
`;

const SupportSection = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding: 30px;
  background: #e9f4ff;
  border: 1px solid #cce6ff;
  border-radius: 12px;

  h2 {
    color: #005f73;
    margin-bottom: 10px;
  }

  p {
    max-width: 700px;
    margin: 0 auto 16px;
    color: #333;
    line-height: 1.6;
    font-size: 20px;
  }

  .cta-button {
    display: inline-block;
    background: #005f73;
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: bold;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5%;
  flex-wrap: wrap;
  h1,
  h2 {
    color: #005f73;

    span {
      color: #fdc500;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 50px;
    text-align: center;
  }
`;
